import { PageHeaderType } from '../../../types/LayoutConfig';

export function migrateTradingLayoutPageHeaders(config: Record<string, any>): void {
  const layouts = config?.spacesConfigs?.trading?.layouts;
  if (!Array.isArray(layouts)) {
    return;
  }

  for (const layout of layouts) {
    if (layout == null || typeof layout !== 'object' || Array.isArray(layout)) {
      continue;
    }

    layout.pageHeader = layout.pageHeader ?? PageHeaderType.TradingDefault;
  }
}
